/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_MicronesiaInputs */

const bn_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মাইক্রোনেশিয়া`)
};

const de_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikronesien`)
};

const el_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μικρονησία`)
};

const en_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Micronesia`)
};

const es_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Micronesia`)
};

const fr_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Micronésie`)
};

const hi_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`माइक्रोनेशिया`)
};

const hu_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikronézia`)
};

const id_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikronesia`)
};

const it_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Micronesia`)
};

const ja_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミクロネシア`)
};

const ko_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`미크로네시아`)
};

const nl_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Micronesië`)
};

const pl_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikronezja`)
};

const pt_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Micronésia`)
};

const ru_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Микронезия`)
};

const sv_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikronesien`)
};

const tr_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikronezya`)
};

const uk_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мікронезія`)
};

const vi_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Micronesia`)
};

const zh_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密克罗尼西亚`)
};

const zh_hant_geo_label_micronesia = /** @type {(inputs: Geo_Label_MicronesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密克羅尼西亞`)
};

/**
* | output |
* | --- |
* | "Micronesia" |
*
* @param {Geo_Label_MicronesiaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_micronesia = /** @type {((inputs?: Geo_Label_MicronesiaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_MicronesiaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_micronesia(inputs)
	if (locale === "de") return de_geo_label_micronesia(inputs)
	if (locale === "el") return el_geo_label_micronesia(inputs)
	if (locale === "en") return en_geo_label_micronesia(inputs)
	if (locale === "es") return es_geo_label_micronesia(inputs)
	if (locale === "fr") return fr_geo_label_micronesia(inputs)
	if (locale === "hi") return hi_geo_label_micronesia(inputs)
	if (locale === "hu") return hu_geo_label_micronesia(inputs)
	if (locale === "id") return id_geo_label_micronesia(inputs)
	if (locale === "it") return it_geo_label_micronesia(inputs)
	if (locale === "ja") return ja_geo_label_micronesia(inputs)
	if (locale === "ko") return ko_geo_label_micronesia(inputs)
	if (locale === "nl") return nl_geo_label_micronesia(inputs)
	if (locale === "pl") return pl_geo_label_micronesia(inputs)
	if (locale === "pt") return pt_geo_label_micronesia(inputs)
	if (locale === "ru") return ru_geo_label_micronesia(inputs)
	if (locale === "sv") return sv_geo_label_micronesia(inputs)
	if (locale === "tr") return tr_geo_label_micronesia(inputs)
	if (locale === "uk") return uk_geo_label_micronesia(inputs)
	if (locale === "vi") return vi_geo_label_micronesia(inputs)
	if (locale === "zh") return zh_geo_label_micronesia(inputs)
	return zh_hant_geo_label_micronesia(inputs)
});